export default __webpack_public_path__ + "static/media/West.26453784.png";